<template>
  <div>
    <p>
      Your permit application has been cancelled. Any saved progress can be resumed at any time
    </p>
  </div>
</template>

<script>
export default {
  name: 'PermitApplicationCancel',
  props: ['projectType'],
};
</script>

<style scoped>

</style>
